import axios from 'axios'
import cookies from 'vue-cookies'
import {
   loginURL,
   logoutURL,
   urlEncoded
   // privilegesIncident,
   // privilegesChange,
   // privilegesZuf
} from '@/utils/constants/constants'

/**
 * Holds the logic for the session handling. It has two functions. One to login at the SBCApi and one to logout again.
 * Login sends the user data input from the Login.vue as parameters to the backend .../login. If successfull a cookie
 * gets stored so Vue knows the user is logged in. If something went wrong the backend sends "?error" back.
 * Logout destroys the session at the backend and deletes the cookie.
 *
 * Holds the logic for accessing views accordingly to privileges. Stores them into localStorage because for some
 * strange reason when not storing them vuex returns always false
 */

// Global state of the app (gets reset after page refresh!)
const state = {
   status: '',
   token: cookies.get('logged_in') || '',
   forwardRoute: null
   // privileges: cookies.get('privileges') || ''
}

const mutations = {
   auth_request(state) {
      state.status = 'loading'
   },
   auth_success(state) {
      state.status = 'success'
   },
   auth_error(state) {
      state.status = 'error'
   },
   logout(state) {
      state.status = ''
      state.token = ''
   },
   setForwardRoute(state, newForwardRoute) {
      state.forwardRoute = newForwardRoute
   }
}

const actions = {
   login({ commit }, user) {
      return new Promise(function(resolve, reject) {
         commit('auth_request')
         axios({
            url: loginURL,
            headers: {
               // IMPORTANT
               'Content-Type': urlEncoded
            },
            params: {
               user_name: user.user_name,
               user_password: user.user_password,
               submit: 'Login'
            },
            withCredentials: true,
            method: 'POST'
         })
            .then(resp => {
               if (resp.request.responseURL.includes('error')) {
                  cookies.remove('logged_in')
                  // eslint-disable-next-line prefer-promise-reject-errors
                  const respHTML = document.createElement('html')
                  respHTML.innerHTML = resp.data
                  const errorReason = respHTML.querySelector('.alert').innerText
                  if (errorReason.includes('disabled')) {
                     reject('accountDisabled')
                  } else if (errorReason.includes('Email')) {
                     reject('emailNotVerified')
                  } else if (errorReason.includes('Phone number')) {
                     reject('phoneNotVerified')
                  } else if (errorReason.includes('reset')) {
                     reject('passwordReset')
                  } else {
                     reject('wrongCredentials')
                  }
               } else {
                  cookies.set('logged_in', '4C4F4C20594147204D4F4D205255', '7d')
                  commit('auth_success')
                  resolve(resp)
               }
            })
            .catch(error => {
               commit('auth_error')
               cookies.remove('logged_in')
               console.log(error)
               reject(error)
            })
      })
   },
   logout({ commit }) {
      return new Promise((resolve, reject) => {
         commit('logout')
         axios({
            url: logoutURL,
            withCredentials: true,
            method: 'POST'
         })
            .then(resp => {
               cookies.remove('logged_in')
               resolve(resp)
            })
            .catch(err => {
               commit('auth_error')
               cookies.remove('logged_in')
               cookies.remove('privileges')
               reject(err)
            })
      })
   }
   // checkPrivileges() {
   //   // Only returns when every privilege is checked
   //   // eslint-disable-next-line no-async-promise-executor
   //   return new Promise(async resolve => {
   //     await this.dispatch('checkIncident')
   //     await this.dispatch('checkChange')
   //     await this.dispatch('checkZUF')
   //     resolve()
   //   })
   // },
   // checkIncident() {
   //   console.log('is checking Incident')

   //   return axios
   //     .get(privilegesIncident)
   //     .then(resp => {
   //       if (resp.data === true) {
   //         cookies.set('privileges', 'incident', '7d')
   //       }
   //     })
   //     .catch(err => {
   //       cookies.remove('privileges')
   //       console.log(err)
   //     })
   // },
   // checkChange() {
   //   console.log('is checking Change')
   //   return axios
   //     .get(privilegesChange)
   //     .then(resp => {
   //       if (resp.data === true) {
   //         let string = cookies.get('privileges') || ''
   //         string += ' change'
   //         cookies.set('privileges', string, '7d')
   //       }
   //     })
   //     .catch(err => {
   //       cookies.remove('privileges')
   //       console.log(err)
   //     })
   // },
   // checkZUF() {
   //   console.log('is checking Zuf')
   //   return axios
   //     .get(privilegesZuf)
   //     .then(resp => {
   //       if (resp.data === true) {
   //         let string = cookies.get('privileges') || ''
   //         string += ' zuf'
   //         cookies.set('privileges', string, '7d')
   //       }
   //     })
   //     .catch(err => {
   //       cookies.remove('privileges')
   //       console.log(err)
   //     })
   // }
}

// Accessors for asking the current state of the app
const getters = {
   isLoggedIn: state => state.token,
   privileges: state => state.privileges,
   authStatus: state => state.status,
   getForwardRoute: state => (state.forwardRoute !== null && state.forwardRoute !== '/signUp' ? state.forwardRoute : '/')
}

export default {
   state,
   mutations,
   actions,
   getters
}
